export default __webpack_public_path__ + "static/media/support-flag-usa.c88db6a5.svg";